function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import ActivityIndicator from '../activity-indicator';

var Button =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Button, _PureComponent);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;

      if (disabled) {
        return;
      }

      if (typeof onClick === 'function') {
        onClick(e);
      }
    };

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          theme = _this$props2.theme,
          size = _this$props2.size,
          shape = _this$props2.shape,
          icon = _this$props2.icon,
          block = _this$props2.block,
          ghost = _this$props2.ghost,
          shadow = _this$props2.shadow,
          disabled = _this$props2.disabled,
          loading = _this$props2.loading,
          onClick = _this$props2.onClick,
          children = _this$props2.children,
          rest = _objectWithoutProperties(_this$props2, ["prefixCls", "className", "theme", "size", "shape", "icon", "block", "ghost", "shadow", "disabled", "loading", "onClick", "children"]);

      var cls = classnames(prefixCls, className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "--").concat(theme), !!theme), _defineProperty(_classnames, "".concat(prefixCls, "--").concat(size), !!size), _defineProperty(_classnames, "".concat(prefixCls, "--").concat(shape), !!shape), _defineProperty(_classnames, "".concat(prefixCls, "--block"), !!block), _defineProperty(_classnames, "".concat(prefixCls, "--ghost"), !!ghost), _defineProperty(_classnames, "".concat(prefixCls, "--shadow"), !!shadow), _defineProperty(_classnames, "".concat(prefixCls, "--disabled"), !!disabled), _classnames));
      var iconRender = loading ? React.createElement(ActivityIndicator, null) : icon;
      var childrenRender = children && React.createElement("span", null, children);
      var contentRender = !!icon || loading ? React.createElement("div", {
        className: "".concat(prefixCls, "__content")
      }, iconRender, childrenRender) : childrenRender;

      if (rest.href !== undefined) {
        var _htmlType = rest.htmlType,
            _filteredRest = _objectWithoutProperties(rest, ["htmlType"]);

        var _ref = _filteredRest,
            _mimeType = _ref.mimeType,
            anchorRest = _objectWithoutProperties(_ref, ["mimeType"]);

        cls = classnames(cls, "".concat(prefixCls, "--link"));
        return React.createElement("a", _extends({}, anchorRest, {
          type: _mimeType,
          "aria-disabled": disabled,
          className: cls,
          onClick: this.onClick
        }), contentRender);
      }

      var mimeType = rest.mimeType,
          target = rest.target,
          filteredRest = _objectWithoutProperties(rest, ["mimeType", "target"]);

      var _ref2 = filteredRest,
          htmlType = _ref2.htmlType,
          nativeRest = _objectWithoutProperties(_ref2, ["htmlType"]);

      return React.createElement("button", _extends({}, nativeRest, {
        type: htmlType,
        "aria-disabled": disabled,
        className: cls,
        onClick: this.onClick
      }), contentRender);
    }
  }]);

  return Button;
}(PureComponent);

Button.displayName = 'Button';
Button.defaultProps = {
  prefixCls: 'za-button',
  theme: 'default',
  size: 'md',
  shape: 'radius',
  block: false,
  ghost: false,
  shadow: false,
  disabled: false,
  loading: false,
  htmlType: 'button'
};
export { Button as default };